module.exports = __webpack_public_path__ + "img/book-heart.ec709757.svg";